import { ClearOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import { SubmitButton } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { FlexRow } from '@framework/ui';
import { Button, Space, Tooltip } from 'antd';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';

export interface SearchActionsProps {
  // fieldRows: Array<{ id: string; name: string | null }>;
  // onReset?: () => void;
  onSaveFilter?: () => void;
  extra?: React.ReactNode;
  add?: React.ReactNode;
}

/**
 * Riga della ricerca con tre colonne: select, input e button
 */
export function SearchActions(props: Readonly<SearchActionsProps>) {
  const { onSaveFilter, extra } = props;
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('sm'));

  return (
    <FlexRow
      right={
        <Space>
          {extra}
          <Button
            htmlType="reset"
            style={{ minWidth: 32 }}
            icon={isMobile && <ClearOutlined aria-hidden />}
            aria-label={t(
              'search.component.search-actions.reset-button.text',
              'Rimuovi filtri',
            )}
          >
            {!isMobile &&
              t(
                'search.component.search-actions.reset-button.text',
                'Rimuovi filtri',
              )}
          </Button>
          <SubmitButton
            size="middle"
            type="primary"
            icon={<SearchOutlined aria-hidden="true" />}
            pristineMessage={t(
              'search.component.search-actions.submit-button.pristine-message',
              'Nessun filtro selezionato',
            )}
          >
            {!isMobile &&
              t('search.component.search-actions.submit-button.text', 'Cerca')}
          </SubmitButton>
        </Space>
      }
    >
      <Space>
        {props.add}
        {props.onSaveFilter && (
          <Tooltip
            title={t(
              'search.component.search-actions.save-filter-button.tooltips',
              'Salva Selezione Filtri',
            )}
          >
            <Button
              aria-label={t(
                'search.component.search-actions.save-filter-button.arial-label',
                'Salva Selezione Filtri',
              )}
              icon={<SaveOutlined aria-hidden="true" />}
              onClick={onSaveFilter}
            />
          </Tooltip>
        )}
      </Space>
    </FlexRow>
  );
}
